import { render, staticRenderFns } from "./MyPageReal.vue?vue&type=template&id=759743f2&scoped=true"
import script from "./MyPageReal.vue?vue&type=script&lang=js"
export * from "./MyPageReal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759743f2",
  null
  
)

export default component.exports